import { create } from "zustand"
import { prepareEditableJsonData, prepareFormValuesFromJson } from "../utils/dataFormat"

interface BearState {
  values: any
  setValues: (newState: any) => void
  updateCouponFrequencyToDefault: () => void
}

const useFormValuesStore = create<BearState>((set) => ({
  values: prepareFormValuesFromJson(prepareEditableJsonData()),
  setValues: (newState) =>
    set((state: any) => {
      return {
        ...state,
        values: { ...newState },
      }
    }),

  updateCouponFrequencyToDefault: () =>
    set((state: any) => {
      return {
        ...state,
        values: {
          ...state.values,
          "Coupon Frequency": "Monthly",
        },
      }
    }),
}))

export default useFormValuesStore

